// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qxP-8","largestCol":"styles_largestCol__IbH-e","smallestCol":"styles_smallestCol__3fE3i"};